import { Star } from 'lucide-react'
import React from 'react'

const Reviews = () => {
    const reviews = [
        {
            name: "John Smith",
            company: "Green Valley Dairy",
            rating: 5,
            text: "Smart Dairy has revolutionized how we manage our milk production. The CRM features are exactly what we needed to streamline our operations."
        },
        {
            name: "Sarah Johnson",
            company: "Fresh Milk Co.",
            rating: 5,
            text: "Outstanding app! The inventory management and customer tracking features have increased our efficiency by 40%. Highly recommended!"
        },
        {
            name: "Mike Wilson",
            company: "Dairy Plus Ltd",
            rating: 5,
            text: "The best dairy management solution we've used. Real-time analytics and easy-to-use interface make it perfect for our business."
        }
    ];
    return (
        <section id="reviews" className="py-20 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <h2 className="text-3xl lg:text-4xl font-bold text-[#002047] mb-4">
                        What Our Customers Say
                    </h2>
                    <p className="text-xl text-gray-600">
                        Join thousands of satisfied dairy businesses using Smart Dairy
                    </p>
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {reviews.map((review, index) => (
                        <div key={index} className="bg-gray-50 p-8 rounded-xl hover:shadow-lg transition-shadow">
                            <div className="flex space-x-1 mb-4">
                                {[...Array(review.rating)].map((_, i) => (
                                    <Star key={i} className="h-5 w-5 text-yellow-400 fill-current" />
                                ))}
                            </div>
                            <p className="text-gray-700 mb-6 leading-relaxed">"{review.text}"</p>
                            <div>
                                <h4 className="font-semibold text-[#002047]">{review.name}</h4>
                                <p className="text-gray-500">{review.company}</p>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="text-center mt-12">
                    <div className="bg-[#002047] text-white p-8 rounded-xl inline-block">
                        <h3 className="text-2xl font-bold mb-2">Join 500+ Happy Customers</h3>
                        <p className="text-blue-100">Start your free trial today and see the difference</p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Reviews
